import { generate_confirmation_token, confirm_authentication_token } from "crud/auth.crud";
import { CONFIRMATION_ACTIONS, USER_TYPE } from "utils/const";
import { DIALOG, AUTH } from "utils/actionsConsts";
// import { recoverPasswordAction } from "./recoverPasswordAction";
import logoutAction from "./logoutAction";
import { recover_password } from "crud/auth.crud";
import { extractApiErrorMessage } from "utils/extractApiErrorMessage";

export const showAuthenticationModalAction = (toShow, username, action, extraData = {}) => async (dispatch) => {
  if (!toShow)
    dispatch({
      type: AUTH.SHOW_CONFIRMATION_MODAL,
      payload: { toShow: false },
    });
  else {
    switch (action) {
      case CONFIRMATION_ACTIONS.CONFIRMATION:
        generate_confirmation_token(username, false)
          .then(() => {
            dispatch({
              type: AUTH.SHOW_CONFIRMATION_MODAL,
              payload: {
                toShow: true,
                actionType: action,
                mobilePhone: username,
              },
            });
          })
          .catch((error) => {
            dispatch({
              type: DIALOG.SHOW,
              payload: {
                showGenericDialog: true,
                genericDialogData: {
                  type: DIALOG.ONE_BUTTON_TYPE,
                  isSuccess: false,
                  message: "Ocorreu um erro a efetuar o seu pedido, por favor tente mais tarde.",
                },
              },
            });
            console.log("error", error);
          });
        break;
      case CONFIRMATION_ACTIONS.RECOVER_PASSWORD: {
        const subjectType = extraData?.subjectType;
        const mappedUserType =
          extraData?.userType ??
          (subjectType === "company"
            ? USER_TYPE.COLLECTIVE
            : subjectType === "citizen"
              ? USER_TYPE.INDIVIDUAL
              : undefined);
        recover_password({
          username,
          foUserTypeId: mappedUserType,
        })
          .then(() => {
            dispatch({
              type: AUTH.SHOW_CONFIRMATION_MODAL,
              payload: {
                toShow: true,
                actionType: action,
                mobilePhone: username,
                subjectType: subjectType,
              },
            });
          })
          .catch((error) => {
            const apiMessage = extractApiErrorMessage(error);
            dispatch({
              type: DIALOG.SHOW,
              payload: {
                showGenericDialog: true,
                genericDialogData: {
                  type: DIALOG.ONE_BUTTON_TYPE,
                  isSuccess: false,
                  message:
                    apiMessage ||
                    "Ocorreu um erro a efetuar o seu pedido, por favor tente mais tarde.",
                },
              },
            });
            console.log("error", error);
          });
        break;
      }
      default:
        dispatch({
          type: AUTH.SHOW_CONFIRMATION_MODAL,
          payload: {
            toShow: true,
            actionType: action,
            mobilePhone: username,
          },
        });
        break;
    }
  }
};

export const confirmAuthenticationAction = (username, token, action) => async (dispatch) => {
  switch (action) {
    case CONFIRMATION_ACTIONS.RECOVER_PASSWORD:
      dispatch(showNewPasswordModalAction(true, username, token));
      break;
    case CONFIRMATION_ACTIONS.CONFIRMATION:
      confirm_authentication_token(username, token)
        .then((res) => {
          dispatch({
            type: DIALOG.SHOW,
            payload: {
              showGenericDialog: true,
              genericDialogData: {
                type: DIALOG.ONE_BUTTON_TYPE,
                isSuccess: res.data,
                message: res.data ? "Conta confirmada com sucesso." : "Código de confirmação incorreto. Tente novamente",
                okAction: () => { dispatch(logoutAction(username)) },
                onCloseAction: () => { dispatch(logoutAction(username)) },
              },
            },
          });
        })
        .catch((error) => {
          dispatch({
            type: DIALOG.SHOW,
            payload: {
              showGenericDialog: true,
              genericDialogData: {
                type: DIALOG.ONE_BUTTON_TYPE,
                isSuccess: false,
                message: "Ocorreu um erro a efetuar o seu pedido, por favor tente mais tarde.",
                okAction: () => { dispatch(logoutAction(username)) },
                onCloseAction: () => { dispatch(logoutAction(username)) },
              },
            },
          });
          ;
          console.log("error", error);
        });
      break;
    default:
      return;
  }
};

export const showNewPasswordModalAction = (toShow, username, token) => async (dispatch) => {
  dispatch({
    type: AUTH.SHOW_NEW_PASSWORD_MODAL,
    payload: {
      toShow: toShow,
      mobilePhone: username,
      resetToken: token,
    },
  });
};
